module.exports = __webpack_public_path__ + "static/media/TrainSchedulerIcon.5fc6ca78.png";